module.exports = __webpack_public_path__ + "static/media/yt.f06d254d.svg";